import {MaskSprite} from '@fantasmagames/core/src/sprites/MaskSprite';
import 'pixi-particles';

export interface ParsedAnimatedMaskParticleArt {
	particleImages: PIXI.Sprite[] | MaskSprite[];
	framerate: number;
	elapsed: number;
	loop: boolean;
	duration: number;
}

export interface AnimatedMaskParticleArt {
	particleImages: PIXI.Sprite[] | MaskSprite[];
	framerate: number | string;
	loop: boolean;
}

export class AnimatedMaskParticle extends PIXI.particles.AnimatedParticle {
	private static readonly DEFAULT_PLUGIN_NAME: string = 'sprite';
	private static readonly MASK_PLUGIN_NAME: string = 'maskSprite';

	private sprites: PIXI.Sprite[] | MaskSprite[];
	private _maskTexture: PIXI.Texture;

	public static parseArt(art: PIXI.particles.AnimatedParticleArt[]): any {
		const outArr: ParsedAnimatedMaskParticleArt[] = [];
		const particleArt = (art as any) as AnimatedMaskParticleArt[];

		for (let i = 0; i < particleArt.length; ++i) {
			const data = particleArt[i];
			const output: ParsedAnimatedMaskParticleArt = (outArr[i] = {} as ParsedAnimatedMaskParticleArt);

			output.particleImages = [...data.particleImages];

			// use these values to signify that the animation should match the particle life time.
			if (data.framerate === 'matchLife') {
				// -1 means that it should be calculated
				output.framerate = -1;
				output.duration = 0;
				output.loop = false;
			} else {
				// determine if the animation should loop
				output.loop = !!data.loop;

				// get the framerate, default to 60
				output.framerate = (data.framerate > 0 ? data.framerate : 60) as number;

				// determine the duration
				output.duration = (output.particleImages.length / output.framerate) as number;
			}
		}

		return outArr;
	}

	public update(delta: number): number {
		const lerp = this.Particle_update(delta);
		const obj = this as any;
		// only animate the particle if it is still alive
		if (lerp >= 0) {
			obj.elapsed += delta;

			if (obj.elapsed + 0.000001 >= obj.duration) {
				// loop elapsed back around
				if (obj.loop) {
					obj.elapsed = obj.elapsed % obj.duration;
				} else {
					// subtract a small amount to prevent attempting to go past the end of the animation
					obj.elapsed = obj.duration - 0.000001;
				}
			}

			const frame = (obj.elapsed * obj.framerate + 0.0000001) | 0;
			// this.texture = obj.textures[frame] || PIXI.Texture.EMPTY;
			if (!this.sprites[frame]) {
				console.error('did not find frame');

				return;
			}
			const sprite = this.sprites[frame];
			this.texture = sprite.texture;
			this.pluginName = AnimatedMaskParticle.DEFAULT_PLUGIN_NAME;

			if (sprite instanceof MaskSprite) {
				this.maskTexture = sprite.maskTexture;
				this.pluginName = AnimatedMaskParticle.MASK_PLUGIN_NAME;
			}
		}

		return lerp;
	}

	public applyArt(art: PIXI.particles.ParsedAnimatedParticleArt): void {
		super.applyArt(art);

		const obj = this as any;
		const particleArt = (art as any) as ParsedAnimatedMaskParticleArt;

		this.sprites = particleArt.particleImages;
		obj.framerate = particleArt.framerate;
		obj.duration = particleArt.duration;
		obj.loop = particleArt.loop;
	}

	public get maskTexture(): PIXI.Texture {
		return this._maskTexture;
	}

	public set maskTexture(value: PIXI.Texture) {
		this._maskTexture = value;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/core/src/particles/AnimatedMaskParticle.ts